import { useState } from 'react';
import { Typography, Box } from '@mui/material';
import { RecordVoiceOver } from '@mui/icons-material';
import eventBus from '../eventBus';
import ACSnackbar from './ACSnackbar';
import NativeShare from './Company/ShareItems/NativeShare';
import {
  isLinkedinAuthenticated,
  authorizeWithPopUp,
} from '../services/LinkedIn';
import LinkedInLogo from './Company/ShareItems/linked_In_logo.svg';

export default function ShareItemsMultiAccount({ isAdvisor }) {
  const [snackbar, setSnackbar] = useState(false);

  const iconStyle = {
    margin: '0 10px',
    cursor: 'pointer',
  };

  return (
    <Box
      display="flex"
      flexDirection={{ xxs: 'column', xs: 'row' }}
      alignItems="center"
      justifyContent={{ xxs: 'center', sm: 'flex-start' }}
      mt={2}
      id="dashboard-invite-buttons"
    >
      <Box display="flex" alignItems="center" mb={{ xxs: 2, xs: 0 }}>
        <RecordVoiceOver
          sx={{
            color: '#4FB5F9',
            mr: '8px',
          }}
        />
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '24px',
            mr: '7px',
          }}
        >
          {isAdvisor ? 'Promote Profile:' : 'Invite Contacts'}
        </Typography>
      </Box>
      <Box>
        <img
          src={LinkedInLogo}
          alt="Linked In Logo"
          id="dashboard-invite-linkedin"
          style={iconStyle}
          onClick={async () => {
            const isAuthenticatedLinkedIn = isLinkedinAuthenticated();
            if (isAuthenticatedLinkedIn) {
              eventBus.dispatch('openLinkedInPostModal');
            } else {
              await authorizeWithPopUp();
            }
          }}
        />
        <img
          src="/icons/facebook_logo.svg"
          id="dashboard-invite-facebook"
          alt="Facebook Logo"
          style={iconStyle}
          onClick={() => {
            eventBus.dispatch('openCopyModal', {
              modalType: 'facebook',
            });
          }}
        />
        <img
          src="/icons/x_logo.svg"
          id="dashboard-invite-x"
          alt="X Logo"
          style={iconStyle}
          onClick={() => {
            eventBus.dispatch('openCopyModal', {
              modalType: 'x',
            });
          }}
        />
        <NativeShare
          iconStyle={iconStyle}
          ids={{ message: 'dashboard-invite-message' }}
        />
        <img
          src="/icons/web_logo.svg"
          alt="Web Logo"
          id="dashboard-invite-copy"
          style={{ ...iconStyle, width: '27px', height: '27px' }}
          onClick={() => {
            eventBus.dispatch('openCopyModal');
          }}
        />
        <img
          src="/icons/email_icon.svg"
          alt="Email Logo"
          id="dashboard-invite-email"
          style={iconStyle}
          onClick={() => {
            eventBus.dispatch('openEmailModal');
          }}
        />
      </Box>
      {isAdvisor && (
        <Box
          id="dashbaordGetFeaturedCta"
          sx={{
            backgroundColor: '#F1F9FF',
            padding: '4px 14px',
            borderRadius: '8px',
            border: '1px solid #4FB5F9',
            mx: { xxs: 0, xs: 1 },
            mt: { xxs: 2, xs: '-6px' },
            cursor: 'pointer',
            width: { xxs: '90%', xs: 'fit-content' },
          }}
        >
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: '16px',
              lineHeight: '24px',
              textAlign: 'center',
            }}
          >
            🚀 Get Featured
          </Typography>
        </Box>
      )}
      <ACSnackbar
        open={snackbar}
        text="Link copied, you can now share it with whoever you choose"
        severity="success"
        onClose={() => setSnackbar(false)}
        autoHideDuration={6000}
      />
    </Box>
  );
}
